import { create } from 'zustand'
import type { IncomingChatData } from '@/features/notifications/components/IncomingChatNotification'

interface IncomingNotificationState {
    notifications: Map<string, IncomingChatData>
    addNotification: (notification: IncomingChatData) => void
    removeNotification: (sessionId: string) => void
    removeByNotificationId: (notificationId: string) => void
    getNotifications: () => IncomingChatData[]
}

export const useIncomingNotificationStore = create<IncomingNotificationState>((set, get) => ({
    notifications: new Map(),

    addNotification: (notification) =>
        set((state) => {
            const updated = new Map(state.notifications)
            updated.set(notification.sessionId, notification)
            return { notifications: updated }
        }),

    removeNotification: (sessionId) =>
        set((state) => {
            const updated = new Map(state.notifications)
            updated.delete(sessionId)
            return { notifications: updated }
        }),

    removeByNotificationId: (notificationId) =>
        set((state) => {
            const updated = new Map(state.notifications)
            for (const [sessionId, notification] of updated.entries()) {
                if (notification.notificationId === notificationId) {
                    updated.delete(sessionId)
                    break
                }
            }
            return { notifications: updated }
        }),

    getNotifications: () => Array.from(get().notifications.values()),
}))
